import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-access-denied',
    imports: [TranslateModule],
    templateUrl: './access-denied.component.html',
    styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {
}
